export class SiterecordIdChange {
  id: string;
  comment: string;
  isInternal: boolean;

  constructor(id: string, comment: string, isInternal: boolean) {
    this.id = id;
    this.comment = comment;
    this.isInternal = isInternal;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/siterecord-id-change.model.ts